<template>
    <div class="import-column" @click="openModal" :class="{
        archived: model.deleted_at,
        loading: loading
     }">
        <div class="heading margin-md-bottom">
            <button class="btn btn-xs btn-danger pull-right"
                    type="button"
                    @click="deleteModel"
                    v-if="model.deleted_at === null">
                <i class="fa fa-trash" aria-hidden="true"></i>
            </button>

            <button class="btn btn-xs btn-primary btn-restore pull-right"
                    type="button"
                    @click="restoreModel"
                    v-else>
                <i class="fa fa-refresh" aria-hidden="true"></i>
            </button>

            <div class="title margin-lg-top">{{model.heading}}</div>
        </div>

        <div class="attribute">
            <select v-model="model.attribute"
                    :disabled="model.deleted_at"
                    name="ImportColumn[attribute]"
                    @change="saveModel"
                    class="form-control">
                <option value="">-</option>
                <option v-for="option in options" :value="option.value"
                        :disabled="option.disabled && option.value !== model.attribute">
                    {{option.label}}
                </option>
            </select>
        </div>

        <div class="effect">
            <div class="radio">
                <label>
                    <input type="radio"
                           :name="'ImportColumn[' + model.id + '][effect]'"
                           v-model="model.effect"
                           @change="saveModel"
                           :value="0"
                           :disabled="model.deleted_at">
                    Match &amp; Update
                </label>
            </div>

            <div class="radio">
                <label>
                    <input type="radio"
                           :name="'ImportColumn[' + model.id + '][effect]'"
                           v-model="model.effect"
                           @change="saveModel"
                           :value="1"
                           :disabled="model.deleted_at">
                    Match
                </label>
            </div>

            <div class="radio">
                <label>
                    <input type="radio"
                           :name="'ImportColumn[' + model.id + '][effect]'"
                           v-model="model.effect"
                           @change="saveModel"
                           :value="2"
                           :disabled="model.deleted_at">
                    Update
                </label>
            </div>

        </div>

        <ul class="list-unstyled summary">
            <li v-for="(value, index) in sample" :key="index" class="truncate">
                <span class="null" v-if="value === null || value === undefined">
                    NULL
                </span>
                <span class="boolean" v-else-if="typeof value === 'boolean'">
                    {{value}}
                </span>
                <span class="string" v-else-if="typeof value === 'number'">
                    {{value}}
                </span>
                <span class="string" v-else-if="typeof value === 'string'">
                    {{value}}
                </span>
                <span class="date" v-else-if="isMoment(value)">
                    {{value | date}}
                </span>
                <span class="unknown text-red" v-else>
                    {{value}}
                </span>
                &nbsp;
            </li>
        </ul>
    </div>
</template>

<script>
    import model from "./mixins/model";
    import moment from "moment";

    export default {
        mixins: [ model ],

        props: {
            options: {
                type: Array
            },

            sample: {
                type: Array
            },
        },

        computed: {
            url(){
                return '/api/importColumns/' + this.model.id;
            },

            saveValidationKey(){
                return 'importColumn'
            },

            resourceKey(){
                return 'ImportColumn';
            },
        },

        methods: {
            afterLoad( loadResults ){
                this.$parent.updateAttributeOptions();

                return Promise.resolve();
            },

            isMoment( value ){
                return moment.isMoment( value );
            },

            getModelData(){
                return {
                    saveResponse: false
                };
            }
        }
    }
</script>
